"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiningReportPage = exports.DiningReportPageActions = void 0;
var diningReportPageActions_1 = require("./diningReportPageActions");
exports.DiningReportPageActions = diningReportPageActions_1.default;
var diningReportPage_1 = require("./diningReportPage");
exports.DiningReportPage = diningReportPage_1.default;
